export default {
  useFixtures: false
}



// WEBPACK FOOTER //
// ./src/Config/index.js